<template>
  <el-dialog title="Alterar Período do Recibo" @open="reset" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="400px">
    <el-form ref="form" :model="reciboAlterado" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="true" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Data de Início" prop="inicioPeriodo">
            <el-date-picker
              v-model="reciboAlterado.inicioPeriodo"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Data Final" prop="fimPeriodo">
            <el-date-picker
              v-model="reciboAlterado.fimPeriodo"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>       
      </el-row>
    </el-form>  
    <span slot="footer">
      <el-button type="primary" size="small" @click="veirificar" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
export default {
  props: {
    recibo: Object,
    visibility: Boolean
  },
  data() {
    return {
      reciboAlterado: {
        inicioPeriodo: undefined,
        fimPeriodo: undefined,
      },

      validacao: {
        inicioPeriodo: [{ required: true }],
        fimPeriodo: [{ required: true }]
      }
      
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', ['alterarRecibo'
    ]),

    veirificar() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.alterarPeriodo({
            ...this.reciboAlterado,
            id: this.recibo.id,
            cliente: {
              id: this.recibo.cliente.id
            },
            aluguel: {
              id: this.recibo.aluguel.id
            } 
          })         
        }else{
          this.$message.warning('Preencha todos os campos.')
          return;
        }
        
        
      });
    },

    alterarPeriodo(payload) {
        this.showLoading();
        this.alterarRecibo(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.concluirAlterarPeriodoRecibo(resultado)
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
        this.fechar();
    },
    reset() {
      this.reciboAlterado = {
        inicioPeriodo: this.recibo.inicioPeriodo,
        fimPeriodo: this.recibo.fimPeriodo,
        id: 0,
        aluguel: {
          id: 0
        },
        cliente: {
          id: 0
        }
      }  
    },
    concluirAlterarPeriodoRecibo(resultado) {
      this.$emit('concluirAlterarPeriodoRecibo',resultado);
    },
    fechar() {
      this.$emit('close');
    } 
  }
}
</script>
